<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('退货订单.销售订单的id,外键(order.id)')" prop="oriOrderId" >
        <a-input v-model="form.oriOrderId" :placeholder="$t('通用.输入.请输入')+$t('退货订单.销售订单的id,外键(order.id)')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.原订单类型20,销售订单,')" prop="type" >
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.提交人id')" prop="submitUserId" >
        <a-input v-model="form.submitUserId" :placeholder="$t('通用.输入.请输入')+$t('退货订单.提交人id')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.用户id,此退款单属于哪个用户')" prop="userId" >
        <a-input v-model="form.userId" :placeholder="$t('通用.输入.请输入')+$t('退货订单.用户id,此退款单属于哪个用户')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.商家id')" prop="shopId" >
        <a-input v-model="form.shopId" :placeholder="$t('通用.输入.请输入')+$t('退货订单.商家id')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.订单退款状态')" prop="refundStatus" >
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.退款金额')" prop="refundAmount" >
        <a-input v-model="form.refundAmount" :placeholder="$t('通用.输入.请输入')+$t('退货订单.退款金额')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.是否仅退款,1.是; 0.否')" prop="isRefundOnly" >
        <a-input v-model="form.isRefundOnly" :placeholder="$t('通用.输入.请输入')+$t('退货订单.是否仅退款,1.是; 0.否')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.是否收到货；1-是，0-否；')" prop="isReceipt" >
        <a-input v-model="form.isReceipt" :placeholder="$t('通用.输入.请输入')+$t('退货订单.是否收到货；1-是，0-否；')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.退款原因')" prop="reason" >
        <a-input v-model="form.reason" :placeholder="$t('通用.输入.请输入')+$t('退货订单.退款原因')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.退款凭证图片')" prop="refundPic" >
        <a-input v-model="form.refundPic" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.退款备注')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('退货订单.显示标记，1：显示，0：不显示，默认1显示')" prop="isDisplay" >
        <a-input v-model="form.isDisplay" :placeholder="$t('通用.输入.请输入')+$t('退货订单.显示标记，1：显示，0：不显示，默认1显示')" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRefund, addRefund, updateRefund } from '@/api/order/refund'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        oriOrderId: null,

        type: null,

        submitUserId: null,

        userId: null,

        shopId: null,

        refundStatus: 0,

        refundAmount: null,

        isRefundOnly: null,

        isReceipt: null,

        reason: null,

        refundPic: null,

        remark: null,

        isDisplay: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        oriOrderId: [
          { required: true, message: this.$t('退货订单.销售订单的id,外键(order.id)')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('退货订单.原订单类型20,销售订单,')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        submitUserId: [
          { required: true, message: this.$t('退货订单.提交人id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: this.$t('退货订单.用户id,此退款单属于哪个用户')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        shopId: [
          { required: true, message: this.$t('退货订单.商家id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        refundAmount: [
          { required: true, message: this.$t('退货订单.退款金额')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isRefundOnly: [
          { required: true, message: this.$t('退货订单.是否仅退款,1.是; 0.否')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('退货订单.退款原因')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isDisplay: [
          { required: true, message: this.$t('退货订单.显示标记，1：显示，0：不显示，默认1显示')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        oriOrderId: null,
        type: null,
        submitUserId: null,
        userId: null,
        shopId: null,
        refundStatus: 0,
        refundAmount: null,
        isRefundOnly: null,
        isReceipt: null,
        reason: null,
        refundPic: null,
        remark: null,
        isDisplay: null,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRefund({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateRefund(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addRefund(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
